window.addEventListener("load", function () {});

$(function () {
  initFront();

  if (document.getElementById("typed")) {
    var typed = new Typed("#typed", {
      stringsElement: "#typed-strings",
      typeSpeed: 70,
      backSpeed: 50,
      backDelay: 200,
      startDelay: 500,
      loop: true,
    });
  }

  if ($("#particles-js").length) {
    // Get the configuration file path from the data-confir attribute
    var configPath = $("#particles-js").data("confir");

    // Load particles.js configuration using the path from the data attribute
    particlesJS.load("particles-js", configPath, function () {
      // Callback when the particles.js config is loaded
      //console.log("particles.js config loaded from: " + configPath);
    });
  }
});

function initFront() {
  console.log("INIT FRONT");
}

/*
(function ($) {
  "use strict";
  setTimeout(function () {
  init();
  core();

  }, 1000);
  
  })(jQuery);

  
const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success btn-pill btn-block',
    cancelButton: 'btn btn-danger btn-pill btn-block'
  },
  buttonsStyling: true
});

function init() {
  $(window).scroll(function (event) { // SCROLL DOWN ARROWS
    var y = $(window).scrollTop();
    if (y > 0) {
      //console.log(y)  
      $(".more-in-down").hide()
    } else {
      $(".more-in-down").show()
    }  
  });

  recapctchaInit(); // CREATES RECAPTCHA TOKEN AND FILL INTO FORM TOKEN FIELD
  
  //$("form").validator('destroy');
  //$("form").off('submit');
  /*
  $('#form').parsley().on('field:validated', function() {
    var ok = $('.parsley-error').length === 0;
    $('.bs-callout-info').toggleClass('hidden', !ok);
    $('.bs-callout-warning').toggleClass('hidden', ok);
  })
  .on('form:submit', function() {
    return false; // Don't submit form for this demo
  });

  /*
  $("form").parsley().on("submit", function (e) {
    var id = $(this).attr('id');
    var form_content = $(this).serializeArray();

    if($('#accept_terms').length){
      var terms = false;
      $.each(form_content, function (i, v) {
        if(v.name=="accept_terms" && v.value=="y"){
          terms = true;
        }
      });

      if(!terms){ $("#accept_terms").addClass('is-invalid');} else {$("#accept_terms").removeClass('is-invalid');}

      var approve = $("#accept_terms").val();

    }
    var catpcha = $(this).data("captcha");

    if (e.isDefaultPrevented()) {  
      Swal.fire({
        title: "Uyarı",
        text: "Lütfen kırmızı ile işaretli alanları doldurun!",
        icon: 'warning',
        confirmButtonColor: "#85FF00",
        confirmButtonText: 'Tamam'
      })
    }
    else if(catpcha=='y'){
      var token = $(this).find("input[name='token']").val()
      $.ajax({
        async: false,
        type: "POST",
        url: "/a/publicActions/reCaptchaVerification",
        data: { token: token},
        success: function (data) {
          if(data == 'fail'){
            e.preventDefault()
            Swal.fire({
              title: "Uyarı",
              text: "Kullanıcının robot olmadığı doğrulanamadı, lütfen tekrar deneyin, sorun devam ederse sistem yöneticileri ile temasa geçin!",
              icon: 'warning',
              confirmButtonColor: "#85FF00",
              confirmButtonText: 'Tamam'
            })
          }
        }
      });
    }    
  });
  

  $(".dynamic").ajaxFormUnbind();
  $(".dynamic").ajaxForm({
    beforeSubmit: function (arr, $form, options) {
      alert("hey")
      $("#general_modal").modal("hide");
      $("#loader .progress-bar").css("width", "0%").html("");
      var ur = options.url;
      
      if (ur.indexOf("contactForm") >= 0 || ur.indexOf("sendRequest") >= 0){$("#loader .loader-title").html("Mesajınız Gönderiliyor");}
      $("#loader .transfer-progress").html("");
      $("#loader").show();
    },
    uploadProgress: function (event, position, total, percentComplete) {
      $("#loader .progress-bar")
        .css("width", percentComplete + "%")
        .html("% " + percentComplete);
      if (total > 102400) {
        $("#loader .transfer-progress").html(
          fileSizeNice(position) + "/" + fileSizeNice(total)
        );
      }
    },
    success: function (xhr) {
      history.replaceState(null, null, " ");
      if (xhr) { 
        if ((resp = isJson(xhr))) { 
          if (resp.hasOwnProperty("status")) {
            $("#loader").hide()
            Swal.fire({
              icon: resp.status,
              title: resp.title,
              html: resp.body,
              timer: resp.timer ? resp.timer : 2000,
              timerProgressBar: true,
              confirmButtonColor: "#85FF00",
              confirmButtonText: "Tamam",
              didOpen: (s) => {
                s.addEventListener("mouseenter", Swal.stopTimer);
                s.addEventListener("mouseleave", Swal.resumeTimer);
              },
            }).then(function () {
              if (resp.hasOwnProperty("destination")) {
                window.location.href = resp.destination;
              }
              else {
                location.reload();
              }
            });
          } else if (resp.hasOwnProperty("destination")) {
            window.location.href = resp.destination;
          }
          else {
            location.reload();
          }
        } else {
          window.location.href = xhr;
        }
      } else {
        location.reload();
      }
    },
  });
  * /
  inputmaskInit()
  dtPickerInit()
  select2Init()
  owlCarouselInit()
}


// INIT FUCNTIONS
function select2Init(){
  $(".select2").select2()
}

function owlCarouselInit(){
  $(".owl-carousel").each(function () {
    var speedT            = ($(this).data("speed") === undefined || $(this).data("speed") === null) ? 5000 : $(this).data("speed");
    var autoPlayT         = ($(this).data("autoplay") === undefined || $(this).data("autoplay") === null) ? true : $(this).data("autoplay");
    var autoPlayTimeOutT  = ($(this).data("autoplay-time-out") === undefined || $(this).data("autoplay-time-out") === null) ? 1500 : $(this).data("autoplay-time-out");
    var autoPlayPause     = ($(this).data("autoplay-pause") === undefined || $(this).data("autoplay-pause") === null) ? true : $(this).data("autoplay-pause");
    var stagePaddingT     = ($(this).data("stage-padding") === undefined || $(this).data("stage-padding") === null) ? 0 : $(this).data("stage-padding");
    var lazyT             = ($(this).data("lazy") === undefined || $(this).data("lazy") === null) ? true : $(this).data("lazy");
    var autoWidtT         = ($(this).data("autowidth") === undefined || $(this).data("autowidth") === null) ? true : $(this).data("autowidth");
    var loopT             = ($(this).data("loop") === undefined || $(this).data("loop") === null) ? true : $(this).data("loop");
    var marginT           = ($(this).data("margin") === undefined || $(this).data("margin") === null) ? 20 : $(this).data("margin");
    var navT              = ($(this).data("nav") === undefined || $(this).data("nav") === null) ? true : $(this).data("nav");
    var dotsT             = ($(this).data("dots") === undefined || $(this).data("dots") === null) ? true : $(this).data("dots");
    var nr_0T             = ($(this).data("nr-0") === undefined || $(this).data("nr-0") === null) ? 1 : $(this).data("nr-0");
    var nr_600T           = ($(this).data("nr-600") === undefined || $(this).data("nr-600") === null) ? 1 : $(this).data("nr-600");
    var nr_1000T          = ($(this).data("nr-1000") === undefined || $(this).data("nr-1000") === null) ? 4 : $(this).data("nr-1000");
    var navPosition       =  ($(this).data("nav-position") === undefined || $(this).data("nav-position") === null) ? 'default' : $(this).data("nav-position");
    var navTextPrev       = ($(this).data("nav-text-prev") === undefined || $(this).data("nav-text-prev") === null) ? "<i class='fa-thin fa-circle-chevron-left fa-3x mx-3 mt-4'></i>" : $(this).data("navTextPrev");
    var navTextNext       = ($(this).data("nav-text-next") === undefined || $(this).data("nav-text-next") === null) ? "<i class='fa-thin fa-circle-chevron-right fa-3x mx-3 mt-4'></i>" : $(this).data("navTextNext");
    
    $(this).owlCarousel({
      smartSpeed: speedT,
      autoplay:autoPlayT,
      autoplayTimeout:autoPlayTimeOutT,
      autoplayHoverPause:autoPlayPause,
      stagePadding: stagePaddingT,
      lazyLoad:lazyT,
      autoWidth:autoWidtT,
      loop:loopT,
      margin:marginT,
      nav:navT,
      dots: dotsT,
      responsive:{
          0:{
              items:nr_0T
          },
          600:{
              items:nr_600T
          },
          1000:{
              items:nr_1000T
          }
      },
      navText : [navTextPrev,navTextNext]
    })
    if(navPosition=='center'){ $(this).addClass("center-owl-navigation") };
  });
}

function recapctchaInit(){
  $("form").each(function() {
    var form = $(this)
    var captcha = form.data("captcha")
    if (captcha == 'y') {
      grecaptcha.ready(function() {
        grecaptcha.execute(form.data("sitekey")).then(function(token) {
          //console.log(token)
          form.find("input[name='token']").val(token);
        });
      });
    }
  })
}

function inputmaskInit(){
  $(":input").inputmask();
}

function dtPickerInit(element) {
  //console.log("dtPickerInit")
  if(typeof element === 'undefined'){
    $(".dpicker").each(function () {
      let that = $(this);
      dtPickerAction(that)
    });
  }
  else {
    let that = $(element);
    dtPickerAction(that)
  }
}
function dtPickerAction(that){
  //console.log(that)
  //console.log(that.attr('id'),that.data("min-date"))
  that.datetimepicker({
    format: that.data("format") ? that.data("format") : "YYYY-MM-DD",
    extraFormats: [that.data("extra-format")],
    minDate: that.data("min-date") ? that.data("min-date") : false,
    maxDate: that.data("max-date") ? that.data("max-date") : false,
    sideBySide: that.data("sidebyside") ? true : false,
    disabledDates: that.data("disabled-dates") ? that.data("disabled-dates") : false,
    stepping: that.data("stepping") ? that.data("stepping") : 1,
    focusOnShow: false,
    ignoreReadonly: true,
    useCurrent: false,
    showTodayButton: true,
    showClear: true,
    showClose: true,
    debug: false,
    allowInputToggle: true
  });
}

function core() {
  if (window.location.hash.substring(1, 14) === "general_modal") {
    var modal_size = window.location.hash.substring(1, 17);
    $("#"+modal_size).modal("show");
    $("#"+ modal_size + " .modal-content").load(
      "/m/" + window.location.hash.substring(18),
      function () {
        $(document).off("focusin.modal");
        $('.bs-select').selectpicker('refresh');
      }
    );
  }
  $(document).on("show.bs.modal", ".general_modal", function (e) {
    $(".dtr-bs-modal").modal("hide");
    var modal_size = $(this).attr('id');
    var target = $(e.relatedTarget);
    //console.log(target)
    $(target.data("bs-target")+" .modal-content").load("/m/" + target.data("link"), function () {
      if (typeof e.relatedTarget != "undefined") {
        window.location.hash = modal_size + "/" + $(e.relatedTarget).data("link");
      }
      $(document).off("focusin.modal");
      $('.bs-select').selectpicker('refresh');
    });
    setTimeout(function () {
      create_form_tokens()
    }, 500);
  });

  $(document).on("click", ".reopen_modal", function (e) {
    var data_link = $(this).data('link');
    var data_target = $(this).data('target');
    $(".general_modal").modal("hide");
    
    setTimeout(function () {
      $("#"+data_target).modal("show");
      $("#"+data_target+" .modal-content").load("/m/" + data_link, function () {
        window.location.hash = data_target +"/" + data_link;
        $(document).off("focusin.modal");
        $('.bs-select').selectpicker('refresh');
      });
    }, 500);
    setTimeout(function () {
      create_form_tokens()
    }, 500);
  });

  $(document).on("hidden.bs.modal", ".general_modal", function (e) {
    $(".general_modal .modal-content").html(
      '<div class="text-center m-5"><i class="fas fa-circle-notch fa-spin fa-5x"></i></div>'
    );
    history.replaceState(null, null, " ");
  });

  $(document).on("change", "input.new-docs-input", function (e) {
    var files = e.target.files;
    var form = $(this).data('form');
    var data_id = $(this).data('id');
    var file_option = (typeof $("#new-file-type").val() === 'undefined') ? '' : $("#new-file-type").val();
    var tmp = $(this).data('tmp-url');
    var tmp_path = $(this).data('tmp-path');
    
    var progress = $('.progress[data-id="' + data_id + '"][data-form="' + form + '"]');
    var progressBar = $('.progress-bar[data-id="' + data_id + '"][data-form="' + form + '"]');
    var alert_bar = $('.alert_load[data-id="' + data_id + '"][data-form="' + form + '"]');

    var uploaded_files = $('.uploaded-files[data-id="' + data_id + '"][data-form="' + form + '"]')
    var uploaded_files_content = $('.uploaded-files-content[data-id="' + data_id + '"][data-form="' + form + '"]')
    var uploaded_files_inputs = $('.uploaded-files-inputs[data-id="' + data_id + '"][data-form="' + form + '"]')
    
    if (files && files.length > 0) {
      file = files[0];
      
      if(file.size > 5000000){
        Swal.fire({
          title: "Uyarı!",
          text: 'Dosyanız en fazla 5MB olabilir.',
          icon: "warning",
          confirmButtonColor: "#85FF00",
          });
      }
      else {
        var list = new Array();
        list.push("image/jpeg");
        list.push("image/png");
        list.push("application/pdf");
        list.push("application/vnd.openxmlformats-officedocument.wordprocessingml.document"); // docx
        list.push("application/msword");
        list.push("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"); //xlsx
        list.push("application/vnd.ms-excel");

        var check_file = checkFileType(file, list);
        
        if (check_file) {
          progress.show();
          alert_bar.removeClass('alert-success alert-warning');
          
          var formData = new FormData();
          formData.append('file', file);
          formData.append('file_type', file.type);

          $.ajax('/a/FrontEnd/uploadFile', {
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,

            xhr: function () {
              var xhr = new XMLHttpRequest();

              xhr.upload.onprogress = function (e) {
                var percent = '0';
                var percentage = '0%';

                if (e.lengthComputable) {
                  percent = Math.round((e.loaded / e.total) * 100);
                  percentage = percent + '%';
                  progressBar.width(percentage).attr('aria-valuenow', percent).text(percentage);
                }
              };
              return xhr;
            },

            success: function (data) {
              var json = $.parseJSON(data);

              var extension = json.substr((json.lastIndexOf('.') + 1));
              if (extension == 'doc' || extension == 'docx') {
                var fa_icon = 'file-word';
              } else if (extension == 'xls' || extension == 'xlsx') {
                var fa_icon = 'file-excel';
              } else if (extension == 'pdf') {
                var fa_icon = 'file-pdf';
              } else if (extension == 'png' || extension == 'jpg' || extension == 'jepg') {
                var fa_icon = 'file-image';
              }

              var cnt = 0;
              $('.uploaded-files-item[data-id="' + data_id + '"][data-form="' + form + '"]').each(function() {
                if($(this).data('cnt') >= cnt){ cnt = $(this).data('cnt')+1 }
              })
              //alert(cnt)
              $(".btn.btn-block.btn-upload-file").hide()
              uploaded_files.removeClass('d-none');

              uploaded_files_content.prepend('<div data-cnt="' + cnt + '" class="text-center mr-3 uploaded-files-item position-relative" data-id="' + data_id + '" data-form="' + form + '"><a data-fancybox="preview" href="' + tmp + '/' + json + '" target="_blank"><i class="fal fa-' + fa_icon + ' fa-5x me-2"></i>' + ((file_option != '') ? '<br>' + file_option : '') + '</a><br><span class="text-danger delete-file position-absolute top-0 end-0" style="cursor:pointer;" data-cnt="' + cnt + '" data-path="' + tmp_path + '/' + json + '" data-id="' + data_id + '" data-form="' + form + '"><i class="fa-solid fa-circle-minus text-danger"></i></span></div>');

              uploaded_files_inputs.append('<input type="text" name="'+data_id+'_uploaded_file[' + cnt + '][name]" data-cnt="' + cnt + '" class="form-control" value="' + file_option + '" data-id="' + data_id + '" data-form="' + form + '"></input>');
             
              uploaded_files_inputs.append('<input type="text" name="'+data_id+'_uploaded_file[' + cnt + '][link]" data-cnt="' + cnt + '" class="form-control  uploaded-file-input" value="' + json + '" data-id="' + data_id + '" data-form="' + form + '"></input>');
              
              alert_bar.show().addClass('alert-success').text($('.progress-bar[data-id="' + data_id + '"][data-form="' + form + '"]').attr("data-success-text"));

              if ($('.uploaded-files-item[data-id="' + data_id + '"][data-form="' + form + '"]').length >= 3) {
                $("#"+form).find(".upload-file-type").addClass("d-none")
                $("#"+form).find(".upload-file-limit").removeClass("d-none")
                uploaded_files_content.find(".btn.btn-upload-file").hide()
              }
              else if ($('.uploaded-files-item[data-id="' + data_id + '"][data-form="' + form + '"]').length > 0) {
                $("#"+form).find(".upload-file-type").removeClass("d-none")
                $("#"+form).find(".upload-file-limit").addClass("d-none")
                uploaded_files_content.find(".btn.btn-upload-file").show()
              }
            },

            error: function () {
              //image_file[image_id].src = initialImageURL;
              alert_bar.show().addClass('alert-warning').text($('.progress-bar[data-id="' + data_id + '"][data-form="' + form + '"]').attr("data-error-text"));
            },

            complete: function () {
              $("#"+form).find('input.new-docs-input').val('');
              progress.hide();
              setTimeout(function () {
                alert_bar.hide()
              }, 2000);
            },
          });
        } else {
          Swal.fire({
            title: "Uyarı!",
            text: 'Sadece .jpg, .png, PDF, Word ve Excel dosyası yükleyebilirsiniz.',
            icon: "warning",
            confirmButtonColor: "#85FF00",
            });
        }
      }
    }
  });

  $("body").on("click", '.delete-file', function (e) {
    e.preventDefault();
    var path = $(this).data("path");
    var cnt = $(this).data("cnt");
    var data_id = $(this).data("id");
    var form = $(this).data("form");
    //console.log(path,cnt,data_id,form);
    Swal.fire({
      title: "Emin misiniz?",
      text: "Silinen dosyalar geri getirilemez!",
      icon: "warning",
      confirmButtonColor: "#85FF00",
      showCancelButton: true,
      showLoaderOnConfirm: true,
      cancelButtonText: "İptal",
      confirmButtonText: "Sil",
      preConfirm: () => {
        Swal.getCancelButton().setAttribute("disabled", "");
        return $.ajax({
            method: "POST",
            async: false,
            url: "/a/FrontEnd/deleteFile",
            data: {
              path: path
            },
          })
          .then((response) => {
            return response;
          })
          .catch((error) => {
            Swal.getCancelButton().removeAttribute("disabled");
            swal.showValidationError(`${error}`);
          });
      },
    }).then(function (result) {
      if (result.value == "success") {
        Swal.fire({
          title: "Silindi!",
          icon: "success",
          confirmButtonColor: "#85FF00",
          timer: 1500,
          timerProgressBar: true
        });
        
        $('.uploaded-files-item[data-cnt="' + cnt + '"][data-id="' + data_id + '"][data-form="' + form + '"]').remove();

        $('input[data-cnt="' + cnt + '"][data-id="' + data_id + '"][data-form="' + form + '"]').remove();
        
        if ($('.uploaded-files-item[data-id="' + data_id + '"][data-form="' + form + '"]').length == 0) {
          $('.uploaded-files[data-id="' + data_id + '"][data-form="' + form + '"]').addClass("d-none");
          $(".btn.btn-block.btn-upload-file").show()
        }
        else if ($('.uploaded-files-item[data-id="' + data_id + '"][data-form="' + form + '"]').length > 0) {
          $("#"+form).find(".upload-file-type").removeClass("d-none")
          $("#"+form).find(".upload-file-limit").addClass("d-none")
          $("#"+form).find(".uploaded-files-content").find(".btn.btn-upload-file").show()
        }
      }
    });
  });

  $(document).on("click",".copy-clipboard", function (e) {
    e.preventDefault();
    var value = $(this).attr("data-value")
    copyToClipboard(value)
    //alert(value);
  });

  $(document).on("click", ".scroll-slow", function (e) {
    var target = $(this).attr("href")
    $('html, body').animate({
      scrollTop: $(target).offset({ top: 100 })
    }, 1000);
  })
}

$(document).ready(function () {
  counter()
  
  $(document).on("change", "#contact_privacy", function (e) {
    if ($('#contact_privacy').is(':checked')) {$("#contact_privacy").val("checked")}
    else {$("#contact_privacy").val("")}
  })

  $(document).on("click", ".cookie-close", function (e) {
    $(".cookie-bar").slideUp()
    $.ajax({
      async: false,
      type: "POST",
      url: "/a/publicActions/cookieCookie",
      success: function (data) {
        //console.log(data)
      }
    })
  })

  $(document).on("click", ".abone-ol-btn", function (e) {
    $(".abone-ol-btn").html('<i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>')
    var email = $("#abone_ol_email").val()

    if(isValidEmail(email)){
      $("#abone-ol-error").addClass("d-none")
      $.ajax({
        async: false,
        type: "POST",
        url: "/a/FrontEnd/newsletterForm",
        data: {'email': email},
        success: function (response) {
          $('#abone-ol-input').addClass('d-none')
          $('#abone-ol-done').removeClass('d-none')
          $('#abone-ol-done').addClass('d-flex')
        }
      });
    }
    else {
      $("#abone-ol-error").removeClass("d-none")
      $(".abone-ol-btn").html('Abone Ol <i class="fa-regular fa-arrow-right ms-2"></i>')
    }
    
    
  })

  $(document).on("click", ".saksi-contact-form-submit", function (e) {
    e.preventDefault();
    $('.saksi-contact-form-submit').prop('disabled', true);
    $('.saksi-contact-form-submit').html('<span class="btn-inner--icon"><i class="fa-solid fa-circle-notch fa-spin me-1"></i></span>Gönderiliyor')
    var form  = $(this).data("form") 
    var cont  = true
    $("#"+form).find(".saksi-talep-form-input").each(function() {
      if (typeof $(this).attr("required") !== 'undefined' && $(this).attr("required") !== false) {
        //console.log($(this).val());
        if($(this).val().length<3){
          cont  = false
          $(this).closest('.input-group').addClass("input-error")
        }
        else{
          $(this).closest('.input-group').removeClass("input-error")
        }
      }
    })
    
    if(cont){
      //console.log(form)
      var form_content = $("#"+form).serializeArray();
      var catpcha = $("#"+form).data("captcha");
      //console.log(form_content)
      //console.log(catpcha)
      if(catpcha=='y'){
        var token = $("#"+form).find("input[name='token']").val()
        $.ajax({
          async: false,
          type: "POST",
          url: "/a/publicActions/reCaptchaVerification",
          data: { token: token},
          success: function (data) {
            if(data == 'fail'){
              e.preventDefault()
              Swal.fire({
                title: "Uyarı",
                text: "Kullanıcının robot olmadığı doğrulanamadı, lütfen tekrar deneyin, sorun devam ederse sistem yöneticileri ile temasa geçin!",
                icon: 'warning',
                confirmButtonColor: "#85FF00",
                confirmButtonText: 'Tamam'
              })
            }
            else{
              $.ajax({
                async: false,
                type: "POST",
                url: "/a/FrontEnd/contactForm",
                data: form_content,
                success: function (response) {
                  data = $.parseJSON(response);
                  $('.saksi-contact-form-submit').prop('disabled', false);
                  $('.saksi-contact-form-submit').html('<span class="btn-inner--icon"><i class="fa-regular fa-paper-plane me-1"></i></span>Gönder')
                  Swal.fire({
                    title: data.status=='fail'? 'Bir sorun oluştu':"Teşekkürler",
                    text: data.title,
                    icon: data.status=='fail'? 'warning':'success',
                    confirmButtonColor: "#85FF00",
                    confirmButtonText: 'Tamam'
                  })
                }
              });
            }
          }
        });
      }  
    }
    else{
      $('.saksi-contact-form-submit').prop('disabled', false);
      $('.saksi-contact-form-submit').html('<span class="btn-inner--icon"><i class="fa-regular fa-paper-plane me-2"></i></span>Gönder')
    }
  });

  $(document).on("click", ".privacy_optin_modal", function (e) {
    e.preventDefault();
    $("#tutor_optin_modal").slideUp();
    $("#privacy_optin_modal").slideDown();
  });

  $(document).on("click", ".close_privacy_term", function (e) {
    e.preventDefault();
    $("#privacy_optin_modal").slideUp();
    $("#tutor_optin_modal").slideUp();
  });
});



function counter(){
  if (document.getElementById('state1')) {
    const countUp = new CountUp('state1', document.getElementById("state1").getAttribute("countTo"));
    if (!countUp.error) {
      countUp.start();
    } else {
      console.error(countUp.error);
    }
  }
  if (document.getElementById('state2')) {
    const countUp1 = new CountUp('state2', document.getElementById("state2").getAttribute("countTo"));
    if (!countUp1.error) {
      countUp1.start();
    } else {
      console.error(countUp1.error);
    }
  }
  if (document.getElementById('state3')) {
    const countUp2 = new CountUp('state3', document.getElementById("state3").getAttribute("countTo"));
    if (!countUp2.error) {
      countUp2.start();
    } else {
      console.error(countUp2.error);
    };
  }
}

function isJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
}

function checkFileType(file, list) {
  var retVal = false;
  $.each(list, function (i, v) {
    if (file.type == v) {
      retVal = true;
    }
  });
  return retVal;
}

function copyToClipboard(value) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val(value).select();
  document.execCommand("copy");
  $temp.remove();
  //location.reload();
}

function smoothToID(id, offset) {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#"+id).offset().top-offset
}, 2000);
}

function isValidEmail(email) {
  var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return regex.test(email);
}
*/
